import { z } from "zod";
import {
    CounterpartyReviewField,
    GENERIC_COUNTERPARTY_REVIEW_FIELD_ENUM,
} from "@common/types/counterpartyFieldReview";

export const counterpartyReviewFieldEnum = z.nativeEnum(
    CounterpartyReviewField,
);

export const genericCounterpartyReviewFieldEnum = z.nativeEnum(
    GENERIC_COUNTERPARTY_REVIEW_FIELD_ENUM,
);

export const counterpartyFieldReviewSchema = z.object({
    id: z.string().uuid(),
    counterpartyId: z.string().uuid(),
    userId: z.number(),
    field: counterpartyReviewFieldEnum,
    createdAt: z.coerce.date(),
});
export type CounterpartyFieldReviewDto = z.infer<
    typeof counterpartyFieldReviewSchema
>;

export const addCounterpartyFieldReviewsBodySchema = z.object({
    fields: z.array(genericCounterpartyReviewFieldEnum).min(1),
});
export type AddCounterpartyFieldReviewsBody = z.infer<
    typeof addCounterpartyFieldReviewsBodySchema
>;

/**
 * Returns the set of fields the given user has reviewed for a counterparty.
 *
 * The add/revoke endpoints operate on the current user, so cell state and
 * "already reviewed" checks must only consider the current user's reviews.
 */
export const getUserReviewedCounterpartyFields = (
    fieldReviews: CounterpartyFieldReviewDto[] | undefined,
    userId: number | undefined,
): Set<CounterpartyReviewField> =>
    new Set(
        (fieldReviews ?? [])
            .filter((review) => review.userId === userId)
            .map((review) => review.field),
    );
